import estoyPidiendoLogoUrl from "../../../../public/logo-estoypidiendo.png";

export function PublicMenuLoadingScreen() {
  return (
    <main className="relative grid min-h-screen place-items-center overflow-hidden bg-[#ff3131] px-6 text-white">
      {/* Decorative watermark */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 top-1/2 -translate-y-1/2 select-none text-center text-[clamp(6rem,22vw,18rem)] font-black leading-none tracking-[-0.08em] text-white/[0.035]"
      >
        EP
      </div>

      <div className="relative flex w-full max-w-sm flex-col items-center text-center">
        {/* Logo */}
        <div className="flex h-20 w-20 items-center justify-center rounded-2xl bg-white">
          <img
            src={estoyPidiendoLogoUrl}
            alt="EstoyPidiendo.com"
            className="h-14 w-14 object-contain"
          />
        </div>

        {/* Brand */}
        <div className="mt-6">
          <p className="text-[2rem] font-black lowercase leading-none tracking-[-0.055em]">
            estoypidiendo
            <span className="text-black">.</span>
            com
          </p>

          <p className="mt-3 text-sm font-medium tracking-[-0.01em] text-white/70">
            preparando tu menú
          </p>
        </div>

        {/* Custom loader */}
        <div
          className="mt-10 flex h-8 items-center gap-1"
          aria-label="Cargando el menú"
          role="status"
        >
          <span className="h-1.5 w-1.5 animate-[menuPulse_1.2s_ease-in-out_infinite] rounded-full bg-white" />

          <span className="h-1.5 w-6 animate-[menuPulse_1.2s_ease-in-out_0.15s_infinite] rounded-full bg-white" />

          <span className="h-1.5 w-1.5 animate-[menuPulse_1.2s_ease-in-out_0.3s_infinite] rounded-full bg-black" />
        </div>
      </div>

      {/* Bottom signature */}
      <div className="absolute bottom-7 left-0 right-0 text-center">
        <span className="text-[10px] font-bold uppercase tracking-[0.28em] text-white/40">
          tu pedido empieza aquí
        </span>
      </div>

      <style>{`
        @keyframes menuPulse {
          0%, 100% {
            opacity: .3;
            transform: scaleX(.7);
          }

          50% {
            opacity: 1;
            transform: scaleX(1);
          }
        }

        @media (prefers-reduced-motion: reduce) {
          [class*="animate-[menuPulse"] {
            animation: none !important;
          }
        }
      `}</style>
    </main>
  );
}
